import axios from "axios";
import { URL } from "../constants/provider/constant";

export const validServices = async () => {
  try {
    let config = {
      method: "post",
      url: URL.providercore_url + "medibuddyCentral/validServices",
      headers: {
        accesstoken: JSON.parse(localStorage.getItem("access_token")),
        accept: "application/json",
      },
      data: {},
    };

    let response = await axios(config);
    return response.data;
  } catch (err) {
    console.log(err);
  }
};

export const locationServiceMap = (roleName, service) => {
  switch (service) {
    case "LABS":
      return "/"+roleName+"/appointments";
    case "OFFLINE_CONSULTS":
      return "/offlineConsults/upcoming";
    default:
      return "/"+roleName+"/appointments";
  }
};
